import request from './request.js';

/**
 * 
 * @param {*} ComponentName 
 * @param {*} downloadParams 
 * @returns 
 */
function generatePdf(ComponentName, downloadParams, formData) {
    const options = {
        endpoint: `/generatePdf`,
        method: 'POST',
        body: {
            componentName: ComponentName,
            downloadParams,
            ...(formData ? { formData } : {})
        }
    };
    
    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    generatePdf
};